import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["media", "srcset"]

import { computed, toRef } from 'vue';
import { imageCandidatesToSrcset } from '@/utils';
import { LabData } from '@/types/LabData';


export default /*@__PURE__*/_defineComponent({
  __name: 'SourceImage',
  props: {
    card: {}
  },
  setup(__props: any) {

const props = __props;

const appImg = toRef(() => props.card.app_img);

const mediaSrcSets = computed(() => ({
  '(max-width: 575px)': imageCandidatesToSrcset({
    '2x': appImg.value['800x560'],
  }),
  '(min-width: 576px)': imageCandidatesToSrcset({
    '1x': appImg.value['400x280'],
  }),
}));


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mediaSrcSets.value, (srcset, media) => {
    return (_openBlock(), _createElementBlock("source", {
      key: media,
      media: media,
      srcset: srcset
    }, null, 8, _hoisted_1))
  }), 128))
}
}

})